module.exports = __webpack_public_path__ + "img/desktop.6d46a679.svg";